// extracted by mini-css-extract-plugin
export default {"applicant-button":"style_applicant-button__fivSi","priority":"style_priority__ErimW","year-options":"style_year-options__xfD-o"};